import React, {useState, useEffect} from 'react';

import {Column, Row} from '../../../components/layout';
import RegisterHeader from '../../../components/headers/register-header';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {addToWizard, setWizard} from '../../../store/actions';
import {
  AppForm,
  AppFormCheckboxField,
  AppFormSubmitButton,
} from '../../../components/forms';
import * as Yup from 'yup';
import {functionalitiesAliasMap, strings} from '../../../util/strings';
import Header1 from '../../../components/headers/header1';
import * as fonts from '../../../util/fonts';
import './styles.scss';
import colors from '../../../util/colors';
import {get, postWithCustomHeaders} from '../../../api/api';
import {
  uriPostConsentReceipts,
  uriStartRegister,
  uriValidateMember,
  uriPostContactsToRegister,
} from '../../../api/endpoints';
import {ApiResponse, getDateInServerFormat} from '../../../util/utility';
import {Link, useHistory} from 'react-router-dom';
import {post} from '../../../api/api';
import MyProfilePopup from './myProfile-popup/MyProfilePopup';
import {ITenant} from '../../../App';

export interface CommunicationsProps {
  wizard: any;
  addToWizard(value: any): void;
  labels: typeof strings.pt.register;
  oneTrust: typeof strings.pt.oneTrust;
  globalStyles: any;
  busFuncMapDefault: any;
  tenant: ITenant;
  language: string;
}

const validationSchema = Yup.object().shape({
  marketingCommunication: Yup.boolean().required(),
  healthAdvices: Yup.boolean().required(),
});

function Communications(props: CommunicationsProps) {
  const {addToWizard, wizard, oneTrust} = props;
  const [submitting, setSubmitting] = useState(false);
  const history = useHistory();

  const featureName = 'Communications';

  const [showMyProfile, setShowMyProfile] = useState(false);

  const nif = wizard?.insuranceValidation?.nif;
  const token = oneTrust?.tokenMyAdv;
  const acceptedTermsAndConditions =
    props.wizard.insuranceValidation?.acceptedTermsAndConditions;
  const acceptedDataTreatment =
    props.wizard.insuranceValidation?.acceptedDataTreatment;
  let purposes: any = [];

  const generateBody = (communicationsConsents: any) => {
    if (acceptedTermsAndConditions) {
      purposes.push({Id: oneTrust?.purposeTermsAndConditions});
    }
    if (acceptedDataTreatment) {
      purposes.push({Id: oneTrust?.purposePolicyDataTreatment});
    }
    if (communicationsConsents.marketingCommunication) {
      purposes.push({Id: oneTrust?.purposeMarketingComunications});
    }
    if (communicationsConsents.healthAdvices) {
      purposes.push({Id: oneTrust?.purposeHealthPrevention});
    }
    return JSON.stringify({
      identifier: nif,
      test: true,
      requestInformation: token,
      purposes: purposes,
    });
  };

  const onSubmit = async (values: any) => {
    setSubmitting(true);
    const {nif, dateOfBirth, name} = props.wizard.insuranceValidation || {};
    const featureName = 'Communications';

    try {
      if (token) {
        try {
          const consentBody = generateBody(values);
          post(uriPostConsentReceipts(), consentBody, false, featureName);
        } catch (consentError) {}
      }

      let sessionId = props.wizard.dataValidation?.currentUser?.sessionId;

      if (!sessionId) {
        let formattedDate = '';
        if (dateOfBirth) {
          try {
            formattedDate = getDateInServerFormat(dateOfBirth);
          } catch (dateError) {
          }
        }

        const body = {
          nif: nif,
          dob: formattedDate,
          fullName: name,
          language: props.language || props.tenant?.mainLanguageAlias || 'PT',
        };

        const customHeaders = {
          headers: {
            'Content-Type': 'application/json',
            'Accept-Language':
              props.language || props.tenant?.mainLanguageAlias || 'PT',
            advSource: 'WebPortal',
            advBu:
              props.wizard.dataValidation?.currentUser?.contacts?.buId ||
              props.tenant?.buDefaultAlias,
            advMemId: props.wizard.insuranceValidation?.memId || '',
            feature: featureName,
            X_MYADV_API_KEY: process.env.REACT_APP_DEFAULT_TENANT_ALIAS,
          },
        };

        const registerRes: any = await postWithCustomHeaders(
          uriStartRegister(),
          JSON.stringify(body),
          customHeaders,
        );

        const isRegistered = !!(
          registerRes?.isRegisteredInWso2 ||
          registerRes?.data?.isRegisteredInWso2
        );

        if (isRegistered) {
          history.push('/utilizador-existente');
          return;
        }

        sessionId = registerRes?.sessionId || registerRes?.data?.sessionId;

        if (sessionId) {
          props.addToWizard({
            dataValidation: {
              ...props.wizard.dataValidation,
              currentUser: {
                ...props.wizard.dataValidation?.currentUser,
                sessionId: sessionId,
              },
            },
          });
          await get(uriValidateMember(sessionId), false, 0, featureName);
        } else {
          throw new Error('SessionId não recebido do servidor.');
        }
      }

      try {
        const contactsRes: any = await post(
          uriPostContactsToRegister(sessionId),
          {},
          false,
          featureName,
        );
        const {phone, email} = contactsRes?.data || {};

        props.addToWizard({
          communications: values,
          dataValidation: {
            ...props.wizard.dataValidation,
            currentUser: {
              ...props.wizard.dataValidation?.currentUser,
              ...(contactsRes?.data || {}),
            },
          },
        });

        if (phone) {
          history.push('/confirmacao-dados/sms');
        } else if (email) {
          history.push('/confirmacao-dados/email');
        } else {
          history.push('/contacto-alternativo');
        }
      } catch (contactsError) {
        props.addToWizard({
          communications: values,
        });
        history.push('/contacto-alternativo');
      }
    } catch (error: any) {
      const status = error?.status ?? error?.response?.status;
      if (status === 409) {
        history.push('/utilizador-existente');
        return;
      }
      history.push('/registo-bloqueado');
    } finally {
      if (window.location.pathname !== '/utilizador-existente') {
        setSubmitting(false);
      }
    }
  };

  return (
    <Column className="register-main-column">
      <RegisterHeader />
      <Row className="register-container app-center">
        <Column className="communications-container-column">
          <AppForm
            className="communications-form-container"
            initialValues={{
              marketingCommunication: false,
              healthAdvices: false,
            }}
            validationSchema={validationSchema}
            onSubmit={async (values) => onSubmit(values)}>
            <Row className="communications-header">
              <Header1
                style={{...fonts.XL, ...fonts.Bold, color: colors.black}}
                className="header-communications">
                {props.labels?.register_beforeContinueTitle}
              </Header1>
              <Header1
                style={{...fonts.L, ...fonts.SemiBold, color: colors.black}}
                className="header-communications-responsive">
                {props.labels?.register_beforeContinueTitle}
              </Header1>
            </Row>
            <Row className="center">
              <Column>
                <Row>
                  <p
                    style={{...fonts.ML}}
                    className="register-before-continue-subtitle1">
                    {props.labels?.register_beforeContinueSubtitle1}
                  </p>
                </Row>
                <Row className="communications-checkbox-row">
                  <AppFormCheckboxField
                    showErrorMessage
                    purposeId={oneTrust?.purposeMarketingComunications}
                    name="marketingCommunication"
                    className="communications-checkbox"
                    label={
                      <label
                        style={{
                          ...fonts.SM,
                          ...fonts.Medium,
                        }}
                        className="align-left-label">
                        {props.labels?.register_beforeContinueCheckbox1Text}{' '}
                        <Link
                          className="communications-anchor"
                          style={{
                            color: props.globalStyles?.primaryColor,
                          }}
                          to="#"
                          onClick={() => setShowMyProfile(true)}>
                          {props.labels?.register_beforeContinueCheckbox1Link}
                        </Link>
                      </label>
                    }
                  />
                </Row>
                <div>
                  <MyProfilePopup
                    show={showMyProfile}
                    setShowModal={setShowMyProfile}
                  />
                </div>
                <Row>
                  <p
                    style={{...fonts.ML}}
                    className="register-before-continue-subtitle2">
                    {props.labels?.register_beforeContinueSubtitle2}
                  </p>
                </Row>
                <Row className="communications-checkbox-row">
                  <AppFormCheckboxField
                    showErrorMessage
                    purposeId={oneTrust?.purposeHealthPrevention}
                    name="healthAdvices"
                    className="communications-checkbox"
                    label={
                      <label
                        style={{...fonts.SM, ...fonts.Medium}}
                        className="align-left-label">
                        {props.labels?.register_beforeContinueCheckbox2Text1}
                        <Link
                          className="communications-anchor"
                          style={{
                            color: props.globalStyles?.primaryColor,
                          }}
                          to="#"
                          onClick={() => setShowMyProfile(true)}>
                          {props.labels?.register_beforeContinueCheckbox2Link}
                        </Link>
                        {props.labels?.register_beforeContinueCheckbox2Text2}
                      </label>
                    }
                  />
                </Row>
                <Row className="app-center">
                  <AppFormSubmitButton
                    disabled={submitting}
                    className="communications-button"
                    title={props.labels?.register_confirmButton}
                  />
                </Row>
              </Column>
            </Row>
          </AppForm>
        </Column>
      </Row>
    </Column>
  );
}

const mapStateToProps = ({
  wizard,
  strings,
  stringsDefault,
  globalStyles,
  busFuncMapDefault,
  tenant,
  language,
}: any) => ({
  wizard: wizard.value,
  labels: stringsDefault.value.pt.register,
  oneTrust: stringsDefault.value.pt.oneTrust,
  globalStyles: globalStyles.value,
  busFuncMapDefault: busFuncMapDefault.value,
  tenant: tenant.value,
  language: language.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  setWizard: (value: any) => dispatch(setWizard(value)),
  addToWizard: (value: any) => dispatch(addToWizard(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(Communications)
);
